import type { LessonConnectionLog } from '../../model/lessons/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface LessonConnectionQualityApiOptions {
  disciplineId: string | number
  lessonId: string | number
}

/** `GET .../lessons/{booking}/connection-quality` — every connection sample of the lesson, newest first. */
export const useLessonConnectionQualityApi = async (
  options: LessonConnectionQualityApiOptions,
): Promise<LessonConnectionLog[] | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.lessons.api.connection-quality', {
    discipline_id: options.disciplineId,
    lesson_id: options.lessonId,
  })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)

    return data.data?.logs ?? []
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))

    return null
  }
}
